import { useCallback } from 'react';
import {
  useQuery,
  useSuspenseQuery,
  QueryResult,
  useLazyQuery,
  useApolloClient,
  QueryOptions,
  QueryHookOptions,
  SuspenseQueryHookOptions,
  LazyQueryHookOptions,
  LazyQueryExecFunction
} from '@apollo/client';
import { useSnackbarHelper } from '../../useSnackbarHelper';
import QUERY from '../operations/InfluencerPostDetail.graphql';
import { Query, QueryinfluencerPostDetailArgs } from '../../__generated__/globalTypes';

export const useInfluencerPostDetailQuery = (options?: QueryHookOptions<Query, QueryinfluencerPostDetailArgs>) => {
  const { t, enqueueSnackbar } = useSnackbarHelper();
  const result = useQuery<Query, QueryinfluencerPostDetailArgs>(QUERY, {
    onError: (error) => {
      enqueueSnackbar(t(error.message), { variant: 'error' });
    },
    ...options
  });

  return result;
};

export const useInfluencerPostDetailLazyQuery = (
  options?: LazyQueryHookOptions<Query, QueryinfluencerPostDetailArgs>
): QueryResult<Query, QueryinfluencerPostDetailArgs> & {
  getInfluencerPostDetail: LazyQueryExecFunction<Query, QueryinfluencerPostDetailArgs>;
} => {
  const { t, enqueueSnackbar } = useSnackbarHelper();
  const [getInfluencerPostDetail, result] = useLazyQuery<Query, QueryinfluencerPostDetailArgs>(QUERY, {
    onError: (error) => {
      enqueueSnackbar(t(error.message), { variant: 'error' });
    },
    ...options
  });

  return { getInfluencerPostDetail, ...result };
};

export const useInfluencerPostDetailPromiseQuery = () => {
  const client = useApolloClient();

  const getInfluencerPostDetail = useCallback(
    (options?: Omit<QueryOptions<QueryinfluencerPostDetailArgs, Query>, 'query'>) =>
      client.query<Query, QueryinfluencerPostDetailArgs>({ ...options, query: QUERY }),
    [client]
  );

  return { getInfluencerPostDetail };
};
// Suspense Query Hooks
export const useInfluencerPostDetailSuspenseQuery = (
  options?: SuspenseQueryHookOptions<Query, QueryinfluencerPostDetailArgs>
) => {
  const result = useSuspenseQuery<Query, QueryinfluencerPostDetailArgs>(QUERY, {
    ...options
  });

  return result;
};
